export default "__VITE_ASSET__5164c3b8__"